<template>
  <div>
    <v-btn
      v-if="titleText === 'DOCS'"
      class="d-inline-flex"
      to="/api"
      text
      aria-label="Docs"
    >
      <span class="text-capitalize mainS--text white--text">API Ref</span>
    </v-btn>
    <v-btn
      class="d-inline-flex"
      to="/docs"
      text
      v-if="titleText === 'API'"
      aria-label="API"
    >
      <span class="text-capitalize mainS--text white--text">Dev Docs</span>
    </v-btn>
    <v-btn
      href="https://support.payfast.co.za/"
      target="_blank"
      text
      class="d-none d-sm-inline-flex ml-4"
      aria-label="Support"
      rel="noreferrer"
    >
      <!--<v-icon left>mdi-face-agent</v-icon>-->
      <span class="text-capitalize mainS--text white--text">Support</span>
    </v-btn>
    <v-btn
      href="https://registration.payfast.io"
      target="_blank"
      rounded
      color="secondary"
      class="sign-up py-5 text-capitalize font-weight-bold white--text px-8 ml-4"
      aria-label="Register"
      rel="noreferrer"
    >
      Sign Up
    </v-btn>
  </div>
</template>

<script>
export default {
  name: "TopBarLinks",
  computed: {
    titleText() {
      return this.$route.name === "api" ? "API" : "DOCS";
    },
  },
};
</script>

<style lang="scss">
.align-content-end {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.v-toolbar .v-toolbar__content {
  .v-chip {
    border-radius: 80px !important;
  }

  .v-btn__content span {
    @extend .gothamBold;
    text-align: center;
    font-weight: 600 !important;
    font-size: 18px !important;
    line-height: 24px !important;
    letter-spacing: normal !important;
  }

  .sign-up {
    display: none;
    @media (min-width: 750px) {
      display: inline-flex;
    }
  }
}
</style>
